<script>
import BOForm from '../../baseComponents/boForm'
import { isDateKey } from '../../variables'

export default {
	extends: BOForm,
	data() {
		return {
			items: [],
			baseItems: [
				{ label: 'Id botnation', value: 'botNationId', type: 'text', required: true, disabled: true },
				{
					label: "listes d'envoi",
					value: 'userLists',
					type: 'multi-select',
					required: false,
					values: () => this.userLists,
					itemText: 'name',
					itemValue: '_id',
				},
				{
					label: 'Clinique',
					value: 'userGroups',
					type: 'multi-select',
					required: false,
					values: () => this.userGroups,
					itemText: 'name',
					itemValue: '_id',
				},
			],
		}
	},
	computed: {
		userGroups() {
			return this.$store.getters.userGroups
		},
		userLists() {
			return this.$store.getters.userLists
		},
		botUserVariables() {
			return this.$store.getters.botUserVariables
		},
	},
	watch: {
		model() {
			this.initModel()
		},
		botUserVariables() {
			this.initVariables()
		},
	},
	mounted() {
		this.initModel()
		this.initVariables()
	},
	methods: {
		initModel() {
			if (this.model && this.model.userVariables) {
				for (let i = 0; i < this.model.userVariables.length; i++) {
					if (!this.model.userVariables[i].bot || this.model.userVariables[i].bot === this.$route.params.botId) {
						this.model[this.model.userVariables[i]._id] = this.model.userVariables[i].value
					}
				}
			}
		},
		initVariables() {
			this.items = [...this.baseItems]

			if (this.botUserVariables && this.botUserVariables.length > 0) {
				for (let i = 0; i < this.botUserVariables.length; i++) {
					const isDate = isDateKey(this.botUserVariables[i].name)

					this.items.push({
						label: (this.botUserVariables[i].bot ? 'specific:' : '') + this.botUserVariables[i].name,
						value: this.botUserVariables[i]._id,
						type: isDate ? 'date' : 'text',
						required: false,
						disabled: this.botUserVariables[i].name === 'licence',
					})
				}
			}
		},
		async post() {},
		async put() {
			let update = {}
			if (this.botUserVariables && this.botUserVariables.length > 0) {
				for (let i = 0; i < this.botUserVariables.length; i++) {
					update[this.botUserVariables[i]._id] = this.model[this.botUserVariables[i]._id]
				}
			}
			update.userLists = this.model.userLists
			update.userGroups = this.model.userGroups

			await this.axios.put('users/' + this.model._id, update)
		},
	},
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/users/user.form.vue